<div class="mt-5 text-xs">{{'survey.select-reason' | translate}}</div>

<div class="flex flex-wrap w-72">
  <button *ngFor="let reason of reasons; index as i" type="button" (click)="onReasonClick(i)"
          [ngClass]="{'tk-border-transparent tk-bg-blue bg-blue-dark-hover': isReasonSelected(i), 'tk-border-gray-2 bg-transparent': !isReasonSelected(i)}"
          class="mr-2 mt-2 rounded-full text-white bg-transparent hover:font-normal">
    <div class="mx-4 my-2">{{reasons[i]}}</div>
  </button>
</div>
